import Vue from "vue";
import Router from "vue-router";
import Cookies from "js-cookie"; // 备用：也可以从 Cookie 里取 token

// import cashier from '@/views/cashier'
import hello from "@/components/hello";
import hi from "@/components/hi";
import navigation from "@/components/navigation";
import order from "@/views/order";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "login", // 登录
      component: () => import("../views/login.vue"),
    },
    {
      path: "/a",
      name: "HelloWorldA",
      component: hi,
    },
    {
      path: "/b",
      name: "HelloWorldB",
      component: hello,
    },
    {
      path: "/test",
      name: "test",
      component: () => import("../views/test.vue"),
    },
    {
      path: "/madt",
      name: "madt",
      component: () => import("../views/madt.vue"),
    },
    {
      path: "/fenjian",
      name: "fenjian", // 分拣
      component: () => import("../views/FenJianPrint.vue"),
    },
    {
      path: "/nav",
      name: "nav",
      redirect: "/nav/cashier",
      component: navigation,
      meta: { requiresAuth: true }, // ← 这层和子路由都需要登录
      children: [
        {
          path: "cashier",
          name: "cashier", // 收银
          component: () => import("../views/cashier.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "commodity",
          name: "commodity", // 货品
          component: () => import("../views/commodity.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "printd",
          name: "printd",
          component: () => import("../views/test.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "order",
          name: "order-nav", // 避免与根级 /order 重名
          component: () => import("../views/order.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "member",
          name: "member",
          redirect: "member/index",
          component: () => import("@/views/member/layout.vue"),
          meta: { requiresAuth: true },
          children: [
            {
              path: "index",
              name: "memberList",
              component: () => import("@/views/member/index.vue"),
              meta: { requiresAuth: true },
            },
            {
              path: "detail",
              name: "memberDetail",
              component: () => import("@/views/member/detail.vue"),
              meta: { requiresAuth: true },
            },
          ],
        },
        {
          path: "shift",
          name: "shift",
          component: () => import("@/views/shift.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "report",
          name: "report",
          component: () => import("@/views/report.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "statment",
          name: "statment",
          component: () => import("@/views/statment.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "system-set",
          name: "systemSet",
          component: () => import("@/views/set/index.vue"),
          meta: {
            requiresAuth: true,
            title: "系统设置 - 收银管理系统",
            name: "系统设置",
          },
        },
        {
          path: "daily",
          name: "日报表",
          component: () => import("@/views/report/daily.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "allReport",
          name: "allReport",
          component: () => import("@/views/report/allReport/index.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "sheqian",
          name: "sheqian",
          component: () => import("@/views/report/sheqian/index.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "today",
          name: "today",
          component: () => import("@/views/report/index.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "dailySales",
          name: "dailySales",
          component: () => import("@/views/report/dailySales/index.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "cashFlow",
          name: "cashFlow",
          component: () => import("@/views/report/cashFlow/index.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "agencySell",
          name: "agencySell",
          component: () => import("@/views/report/agencySell/index.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "lotDetail",
          name: "lotDetail",
          component: () => import("@/views/report/lotDetail/index.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "abnormalHandle",
          name: "abnormalHandle",
          component: () => import("@/views/report/abnormalHandle/index.vue"),
          meta: { requiresAuth: true },
        },
				{
				  path: "banCiTongJiBiao",
				  name: "banCiTongJiBiao",
				  component: () => import("@/views/report/banCiTongJiBiao/index.vue"),
				  meta: { requiresAuth: true },
				},
      ],
    },
    {
      path: "/order",
      name: "order",
      component: order,
      meta: { requiresAuth: true },
    },
    {
      path: "/print",
      name: "print",
      component: () => import("@/views/set/print.vue"),
      meta: {
        requiresAuth: true,
        title: "标签打印 - 收银管理系统",
        name: "标签打印",
      },
    },
  ],
});

/**
 * 简单网络检测：
 * 1) navigator.onLine 粗判
 * 2) 再 HEAD 一下 favicon（你可以改成自己的 ping 接口）
 */
function checkNetwork() {
  if (navigator.onLine === false) {
    // 浏览器已经认为是离线了
    return Promise.resolve(false);
  }
  // 再做一次实际请求，判断服务端是否可达
  return fetch(`/favicon.ico?_t=${Date.now()}`, {
    method: "HEAD",
    cache: "no-cache",
  })
    .then(() => true)
    .catch(() => false);
}

// ===== 全局路由守卫：token + 网络通畅 =====
router.beforeEach(async (to, from, next) => {
  // 1) 取 token（localStorage 优先，没取到再看 Cookie）
  const token =
    localStorage.getItem("token") || Cookies.get("token") || "";
  const hasToken =
    !!(token && token.trim() !== "" && token !== "undefined");

  // 2) 判断网络是否通畅
  const netOK = await checkNetwork();
if (!netOK) {
  console.warn("当前网络看起来不通畅");

  if (to.meta && to.meta.requiresAuth) {
    // 用 ElementUI 漂亮提示
    Message({
      message: "当前网络不可用，请检查网络连接",
      type: "warning",
      showClose: true,
      duration: 3000,
    });

    // 保持原来逻辑：打回登录页
    return next("/");
    // 如果你想停留在当前页不跳走，也可以改成：
    // return next(false);
  }

  // 访问登录页 / 非受保护页面，直接放行
  return next();
}


  // 3) 不再校验 token 是否有效，只要本地有就认为已登录
  const authed = hasToken;

  if (authed) {
    // 已登录：不允许回登录页
    if (to.path === "/" || to.name === "login") {
      try {
        // ===== 在自动跳转首页之前，检查 printer_info / userInfo =====
        let printer_info = JSON.parse(
          localStorage.getItem("printer_info") || "{}"
        );
        let userInfo = JSON.parse(
          localStorage.getItem("userInfo") || "{}"
        );

        try {
          let flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
          );

          if (flag && window.Android) {
            let disconnect = window.Android.dIsDeviceConnected();

            if (!disconnect) {
              if (printer_info) {
                window.Android.activateBaidu();
              }

              if (
                userInfo.print &&
                userInfo.print.use_printer_name &&
                userInfo.print.use_printer_id
              ) {
                let blue_res =
                  window.Android.dGetPairedBluetoothDeviceList() ||
                  "[]";
                let usb_res =
                  window.Android.dGetUsbDeviceList() || "[]";
                let blue_device = JSON.parse(blue_res);
                let usb_device = JSON.parse(usb_res);
                let s = userInfo.print.use_printer_name || "";

                let if_blue =
                  s.indexOf("POS") !== -1 || /^test$/i.test(s);

                if (if_blue) {
                  blue_device.forEach((item) => {
                    if (
                      item.address ==
                      userInfo.print.use_printer_id
                    ) {
                      window.Android.dConnectBlueToothDevice(
                        userInfo.print.use_printer_id
                      );
                    }
                  });
                } else {
                  usb_device.forEach((item) => {
                    if (
                      item.id == userInfo.print.use_printer_id
                    ) {
                      window.Android.dConnectUsbDevices(
                        userInfo.print.use_printer_id
                      );
                    }
                  });
                }
              }
            }
          }
        } catch (error) {
          console.error("Android 打印机逻辑异常:", error);
        }
      } catch (e) {
        console.warn("printer_info / userInfo 解析失败:", e);
      }

      // 守卫里不要用 this.$router，直接 next()
      return next("/nav/cashier");
    }

    // 正常访问其它页面
    return next();
  } else {
    // 未登录：只允许访问登录页；访问其它受保护路由则重定向到登录
    if (to.meta && to.meta.requiresAuth) return next("/");
    if (to.path !== "/" && to.name !== "login") return next("/");
    return next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js